// 약국 취급 품목 관련 유틸
const BAQSIMI_NAMES = ['바크시미', '바크시미나잘스프레이'];

export default {
    // 취급 품목에 바크시미(바크시미나잘스프레이)가 있는지
    // medicines 는 "A, B" 형태의 문자열 또는 배열. 공백은 무시하고 비교한다.
    hasBaqsimi: function(medicines)
    {
        if(medicines === null || medicines === undefined || medicines === '')
        {
            return false;
        }

        const list = Array.isArray(medicines) ? medicines : String(medicines).split(',');
        return list.some((medicine) => {
            return BAQSIMI_NAMES.indexOf(String(medicine).replace(/\s/g, '')) > -1;
        });
    }
}



// WEBPACK FOOTER //
// ./src/utilities/medicine.js